<template>
  <div class="btn" @click="clickfun">
    <el-button
      type="primary"
      :loading="false"
      class="loadButton"
      color="#fff"
      width="1070px"
    >{{isGaonS?isEnglish?"Load more...":"加载更多...":"加载更多..."}}</el-button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "loadButton",
  props: {
    value: {
      type: Number,
      default() {
        return 1;
      }
    }
  },
  computed: {
    ...mapGetters(["isGaonS", "isEnglish"]),
    page: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    clickfun() {
      this.page++;
    }
  }
};
</script>

<style lang="less" scoped>
.btn {
  width: 100%;
}
.loadButton {
  display: block;
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  color: #fff;
  line-height: 20px;
  width: 1070px;
  height: 50px;
  margin: 51px auto;
  // background:linear-gradient(180deg,rgba(234,234,234,1),rgba(222,222,222,1));
  background-color: rgb(14, 130, 239);
  border: none;
  border-radius: 3px;
}
.loadButton:hover {
  background-color: #66b2ff;
}
</style>



// WEBPACK FOOTER //
// src/components/loadButton.vue